import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Logo from '../Logo';
import { DownloadIcon, AlertTriangleIcon } from '../icons';
import { watchApi } from '../../api';

export default function WatchPage() {
  const { code } = useParams();
  const [state, setState] = useState({ loading: true, data: null, error: null });

  useEffect(() => {
    let cancelled = false;
    watchApi.get(code)
      .then(data => { if (!cancelled) setState({ loading: false, data, error: null }); })
      .catch(err => {
        if (cancelled) return;
        const detail = err.response?.data?.detail || "This link has expired or the recording has been removed.";
        setState({ loading: false, data: null, error: detail });
      });
    return () => { cancelled = true; };
  }, [code]);

  return (
    <div style={s.page}>
      <div style={s.card} className="fade-in">
        <div style={s.brand}>
          <Logo size={28} style={{ marginRight: 10 }} />
          <div>
            <div style={s.brandName}>Picklers Lounge</div>
            <div style={s.brandSub}>Court Recording System</div>
          </div>
        </div>

        {state.loading && (
          <div style={s.msgBlock}>
            <span style={s.spinner} />
            <p style={s.msgText}>Loading your recording…</p>
          </div>
        )}

        {!state.loading && state.error && (
          <div style={s.msgBlock}>
            <div style={s.errIcon}><AlertTriangleIcon size={26} color="#d97706" /></div>
            <p style={s.msgText}>{state.error}</p>
          </div>
        )}

        {!state.loading && state.data && (
          <>
            <div style={s.meta}>
              <span style={s.court}>{state.data.court_name}</span>
              <span style={s.dot}>&middot;</span>
              <span>{state.data.duration_display}</span>
              <span style={s.dot}>&middot;</span>
              <span>{state.data.recorded_on}</span>
            </div>

            <video
              key={state.data.stream_url}
              style={s.player}
              controls
              preload="metadata"
              src={state.data.stream_url}
            />

            <a href={state.data.download_url} download style={s.downloadBtn}>
              <DownloadIcon size={16} color="#ffffff" style={{ marginRight: 8 }} />
              Download Video
            </a>
          </>
        )}
      </div>
    </div>
  );
}

const s = {
  page: {
    minHeight: '100vh', background: 'var(--blue-light)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    padding: '32px 16px', fontFamily: 'var(--font)',
  },
  card: {
    width: '100%', maxWidth: 560,
    background: 'var(--white)', borderRadius: 'var(--radius-lg)',
    boxShadow: 'var(--shadow-lg)', overflow: 'hidden',
  },
  brand: {
    display: 'flex', alignItems: 'center',
    padding: '20px 24px', borderBottom: '3px solid var(--blue)',
  },
  brandName: { fontSize: 15, fontWeight: 700, color: 'var(--gray-900)' },
  brandSub: {
    fontSize: 11, color: 'var(--gray-400)', fontWeight: 600,
    textTransform: 'uppercase', letterSpacing: '0.06em',
  },
  meta: {
    padding: '14px 24px', background: 'var(--blue-light)',
    fontSize: 13, color: 'var(--gray-700)',
  },
  court: { fontWeight: 700, color: 'var(--blue-dark)' },
  dot: { margin: '0 8px', color: 'var(--gray-400)' },
  player: {
    display: 'block', width: '100%', maxHeight: '70vh',
    background: '#000',
  },
  downloadBtn: {
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    margin: '20px 24px 28px', padding: 14,
    borderRadius: 50, background: 'var(--green)', color: '#fff',
    fontWeight: 700, fontSize: 15, textDecoration: 'none',
  },
  msgBlock: {
    padding: '56px 32px', textAlign: 'center',
  },
  spinner: {
    width: 32, height: 32, borderRadius: '50%',
    border: '3px solid var(--gray-200)', borderTopColor: 'var(--blue)',
    display: 'inline-block', animation: 'spin 0.8s linear infinite',
    marginBottom: 20,
  },
  errIcon: { marginBottom: 16 },
  msgText: { fontSize: 15, color: 'var(--gray-600)', lineHeight: 1.6 },
};
